import React from 'react';
import PropTypes from 'prop-types';

export default function Triangle({ width = 10, height = 6, color = '#07cb25' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.949381 6C0.698769 6 0.458339 5.89958 0.280602 5.72069C0.19169 5.63139 0.121118 5.52516 0.0729571 5.40811C0.0247965 5.29106 7.2953e-08 5.16551 8.40382e-08 5.03871C9.51235e-08 4.91191 0.0247966 4.78637 0.0729572 4.66932C0.121118 4.55227 0.19169 4.44604 0.280603 4.35674L4.35019 0.284121C4.43838 0.194093 4.5433 0.122635 4.6589 0.0738707C4.7745 0.0251065 4.89849 -4.45988e-07 5.02372 -4.35041e-07C5.14895 -4.24093e-07 5.27294 0.0251065 5.38854 0.0738707C5.50413 0.122635 5.60905 0.194093 5.69724 0.284121L9.7194 4.35674C9.80831 4.44604 9.87888 4.55227 9.92704 4.66932C9.9752 4.78637 10 4.91191 10 5.03871C10 5.16552 9.9752 5.29106 9.92704 5.40811C9.87888 5.52516 9.80831 5.63139 9.7194 5.72069C9.54166 5.89959 9.30123 6 9.05062 6L0.949381 6Z"
        fill={color}
      />
    </svg>
  );
}

Triangle.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};
